<template>
    <div class="sup-dev-demo-comp">
        <div class="re-w1200 re-main-col">
            <div class="type-title-box">
                <div class="title-blue-line"></div>
                <span class="title">开发示例DEMO</span>
                <img src="@/assets/imgs/devDoc/more_btn.png" @click="jump_demo_click" />
            </div>
            <div class="grid-list-box">
                <div class="grid-item-box" v-for="(item, index) in dev_demo_list" :key="`item_${index}`" @click="jump_demo_item_click(item)">
                    <div class="item-left-box">
                        <img :src="downloadBaseUrl_computed(item.thumbnail)" />
                    </div>
                    <div class="item-right-box">
                        <span class="item-title">{{ item.name }}</span>
                        <span class="item-dis">{{ item.description }}</span>
                        <div class="item-btn">
                            <span>查看Demo</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, computed } from 'vue';
import { useRouterStore } from '@/stores/router';

const router_store = useRouterStore();

const props = defineProps({
    dev_demo_list: {
        type: Array,
        default: () => [],
    },
});

const downloadBaseUrl_computed = computed(() => (path) => {
    let url = '';
    if (path && path.length) {
        url = `${window.downloadBaseUrl}/${path}`;
    }
    return url;
});

// MARK Click  跳转Demo示例
const jump_demo_click = () => {
    router_store.navigateToDemo();
};

// MARK Click Item  跳转Demo示例
const jump_demo_item_click = (item) => {
    router_store.navigateToDemo({ shareType: 1, treeId: item.dcId });
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-dev-demo-comp {
    position: relative;
    display: flex;
    justify-content: center;

    .type-title-box {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;

        .title-blue-line {
            position: relative;
            width: 6px;
            height: 48px;
            border-radius: 1px;
            background: var(--color-main-brand);
        }

        .title {
            position: relative;
            margin-left: 20px;
            height: 48px;
            flex: 1;
            font-weight: 400;
            font-size: 32px;
            color: var(--color-main-text-primary);
        }

        img {
            position: relative;
            margin-right: 0;
            width: 36px;
            height: 36px;
            cursor: pointer;
            border-radius: 18px;
            outline: 0 solid transparent;
            transition: var(--animation-outline-style);

            &:hover {
                outline: 4px solid var(--color-main-outline-hover);
            }
        }
    }

    .grid-list-box {
        position: relative;
        width: 100%;
        margin-top: 47px;
        flex-shrink: 0;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        column-gap: 80px;
        row-gap: 44px;

        .grid-item-box {
            position: relative;
            display: flex;
            height: 220px;
            padding: 14px;
            box-sizing: border-box;
            border-radius: 10px;
            cursor: pointer;
            background-color: var(--color-main-light-bg-white);
            box-shadow: var(--color-main-card-shadow-small);
            border: 2px solid var(--color-main-transparent-bg);
            transition: var(--animation-border-style);

            .item-left-box {
                position: relative;
                width: 193px;
                height: 100%;
                flex-shrink: 0;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 6px;
                }
            }

            .item-right-box {
                position: relative;
                display: flex;
                flex: 1;
                height: 100%;
                flex-direction: column;
                align-items: flex-end;
                margin-left: 21px;
                margin-right: 6px;

                .item-title {
                    position: relative;
                    width: 100%;
                    height: 30px;
                    font-weight: 500;
                    font-size: 20px;
                    color: var(--color-main-text-primary);
                    display: flex;
                    align-items: center;
                }

                .item-dis {
                    position: relative;
                    margin-top: 26px;
                    width: 100%;
                    flex: 1;
                    font-size: 13px;
                    font-weight: 400;
                    color: var(--color-main-text-secondary);
                }

                .item-btn {
                    position: relative;
                    width: 93px;
                    height: 27px;
                    margin-bottom: 6px;
                    background: var(--color-main-brand);
                    border-radius: 2px;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    span {
                        position: relative;
                        margin-top: -1px;
                        height: 16px;
                        font-weight: 400;
                        font-size: 13px;
                        line-height: 16px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: var(--color-main-text-brand-bg-primary);
                    }
                }
            }

            &:hover {
                border: 2px solid var(--color-main-brand-hover);
            }
        }
    }
}
</style>
